import moment from 'moment'

export function formatLooseDate (time) {
  return moment(time).format('ddd DD.MM.YYYY')
}

export function formatStrictDate (time) {
  return moment(time).format('DD.MM.YY')
}

export function formatDateTime (datetime) {
  return moment(datetime).format('DD.MM.YYYY HH:mm')
}

export function formatTime (datetime) {
  return moment(datetime).format('HH:mm')
}
